import { jsx } from '@amazon/vinyl-tsx'

export function ErrorMessage(props: { message: string }) {
    return <div className="errorMessage">{props.message}</div>
}
